// eslint-disable-next-line import/prefer-default-export
import axios from 'axios';
import { baseUrl } from '../utils/constants';

export const getUnionSearch = async (search = '', page = 1, pageSize = 10) => axios.get(
  `${baseUrl()}r/unions/?page=${page}&pageSize=${pageSize}${search ? `&search=${search}` : ''}`, { withCredentials: true },
);

export const getUnion = async (unionId) => axios.get(
  `${baseUrl()}r/unions/${unionId}/`, { withCredentials: true },
);

export const getUnionsFromMarket = async (marketId) => axios.get(
  `${baseUrl()}unions/getUnion/${marketId}`, { withCredentials: true },
);

export const createUnion = async (payload) => axios.post(
  `${baseUrl()}r/unions/`, payload, { withCredentials: true },
);

export const updateUnion = async (payload) => axios.patch(
  `${baseUrl()}r/unions/${payload.id}/`, payload, { withCredentials: true },
);

export const deleteUnion = async (id) => axios.delete(
  `${baseUrl()}r/unions/${id}/`,
);

export const getUnions = () => [
  {
    union: 'NON',
    occupations: [
      {
        name: 'Chef Assistant',
        altName: 'Chef Assistant',
      },
      {
        name: 'Caterer',
        altName: 'Caterer',
      },
      {
        name: 'Choreographer',
        altName: 'Choreographer',
      },
      {
        name: 'Consultant',
        altName: 'Consultant',
      },
      {
        name: 'Director\'s Assistant',
        altName: 'Director\'s Assistant',
      },
      {
        name: 'DGA Trainee',
        altName: 'DGA Trainee',
      },
      {
        name: 'Fire Safety Advisor',
        altName: 'Fire Safety Advisor',
      },
      {
        name: 'Fire Safety Officer',
        altName: 'Fire Safety Officer',
      },
      {
        name: 'Police Officer',
        altName: 'Police Officer',
      },
      {
        name: 'Groomer',
        altName: 'Groomer',
      },
      {
        name: 'Lifeguard',
        altName: 'Lifeguard',
      },
      {
        name: 'Manager',
        altName: 'Manger (Site Manager)',
      },
      {
        name: 'Manicurist',
        altName: 'Manicurist',
      },
      {
        name: 'Product Specialist',
        altName: 'Product Specialist',
      },
      {
        name: 'Security',
        altName: 'Security',
      },
      {
        name: 'Researcher',
        altName: 'Researcher',
      },
      {
        name: 'Translator',
        altName: 'Translator',
      },
      {
        name: 'Stylist',
        altName: 'Stylist',
      },
      {
        name: 'Wardrobe Assistant',
        altName: 'Wardrobe Assistant',
      },
      {
        name: 'Treatment Writer / EXEMPT',
        altName: 'Treatment Writer / EXEMPT',
      },
      {
        name: 'Treatment Visualist / EXEMPT',
        altName: 'Treatment Visualist / EXEMPT',
      },
      {
        name: 'Writer / Exempt',
        altName: 'Writer / Exempt',
      },
    ],
  },
  {
    union: 'PHBP',
    occupations: [
      {
        name: 'Producer PHBP / EXEMPT',
        altName: 'Producer PHBP / EXEMPT',
      },
      {
        name: 'Production Supervisor PHBP / EXEMPT',
        altName: 'Production Supervisor PHBP / EXEMPT',
      },
      {
        name: 'Commercial Coordinator PHBP',
        altName: 'Commercial Coordinator PHBP',
      },
      {
        name: 'Assistant Commercial Coordinator',
        altName: 'Assistant Commercial Coordinator',
      },
      {
        name: 'Production Assistant PHBP',
        altName: 'Production Assistant PHBP',
      },
      {
        name: 'Compliance Assistant PHBP',
        altName: 'Compliance Assistant PHBP (PA)',
      },
      {
        name: 'Bidder PHBP / EXEMPT',
        altName: 'Bidder PHBP / EXEMPT',
      },
      {
        name: 'Consultant PHBP / EXEMPT',
        altName: 'Consultant PHBP / EXEMPT',
      },
      {
        name: 'DOT Coordinator PHBP',
        altName: 'DOT Coordinator PHBP',
      },
      {
        name: 'Travel Coordinator PHBP / EXEMPT',
        altName: 'Travel Coordinator PHBP / EXEMPT',
      },
    ],
  },
  {
    union: '16',
    occupations: [],
  },
  {
    union: '44',
    occupations: [
      {
        name: 'Property Master',
        altName: 'Property Master',
      },
      {
        name: '2nd Prop (Asst. Prop)',
        altName: '2nd Prop',
      },
      {
        name: '3rd Prop',
        altName: '3rd Prop',
      },
      {
        name: 'Set Decorator Daily On-Call',
        altName: 'Set Decorator Daily On-Call',
      },
      {
        name: 'Lead Set Dresser',
        altName: 'Lead Set Dresser',
      },
      {
        name: 'Shopper',
        altName: 'Shopper',
      },
      {
        name: 'Construction Coordinator Daily On-Call',
        altName: 'Greensman Lead',
      },
      {
        name: 'Greens Man',
        altName: 'Greens Man',
      },
      {
        name: 'Special Effect Foreperson',
        altName: 'Special Effect Foreperson',
      },
      {
        name: 'Lead Effects',
        altName: 'Lead Effects',
      },
      {
        name: 'Special Effects',
        altName: 'Propmaker Foreperson',
      },
      {
        name: 'Propmaker Foreperson',
        altName: 'Propmaker Foreperson',
      },
    ],
  },
  {
    union: '80',
    occupations: [
      {
        name: 'Key Grip',
        altName: 'Key Grip',
      },
      {
        name: 'Best Boy Grip',
        altName: 'Best Boy Grip',
      },
      {
        name: 'Grip',
        altName: 'Grip',
      },
      {
        name: 'Dolly Grip',
        altName: 'Dolly Grip',
      },
      {
        name: 'Entry Level Grip',
        altName: 'Entry Level Grip',
      },
      {
        name: 'Crane Operator',
        altName: 'Crane Operator',
      },
      {
        name: 'Layout Board',
        altName: 'Layout Board',
      },
      {
        name: 'Craft Service',
        altName: 'Craft Service',
      },
      {
        name: 'Marine Coordinator',
        altName: 'Marine Coordinator',
      },
      {
        name: 'Vessel Captain',
        altName: 'Vessel Captain',
      },
      {
        name: 'Diver',
        altName: 'Diver',
      },
      {
        name: 'Rigger',
        altName: 'Rigger',
      },
      {
        name: 'First Aid',
        altName: 'First Aid',
      },
      {
        name: 'Medical',
        altName: 'Medical',
      },
    ],
  },
  {
    union: 'L305',
  },
  {
    union: '399',
    occupations: [
      {
        name: 'Gang Boss',
        altName: 'Gang Boss (Transpo Captain)',
      },
      {
        name: 'Drivers - Class A',
        altName: 'Drivers - Class A',
      },
      {
        name: 'Drivers - Class B',
        altName: 'Drivers - Class B',
      },
      {
        name: 'Drivers - Class C',
        altName: 'Drivers - Class C',
      },
      {
        name: 'Location Scout',
        altName: 'Location Scout',
      },
      {
        name: 'Location Manager',
        altName: 'Location Manager',
      },
      {
        name: 'Camera Car Driver',
        altName: 'Camera Car Driver',
      },
      {
        name: 'Van Driver',
        altName: 'Van Driver',
      },
      {
        name: 'Teamster / 15 Pass Van',
        altName: 'Teamster / 15 Pass Van',
      },
      {
        name: 'Stakebed Driver',
        altName: 'Stakebed Driver',
      },
      {
        name: 'Honeywagon Driver',
        altName: 'Honeywagon Driver',
      },
      {
        name: 'Motorhome Driver',
        altName: 'Motorhome Driver',
      },
      {
        name: 'Animal Wrangler Domestic',
        altName: 'Animal Wrangler Domestic',
      },
      {
        name: 'Animal Trainer Domestic',
        altName: 'Animal Trainer Domestic',
      },
      {
        name: 'Wild Animal Trainer',
        altName: 'Wild Animal Trainer',
      },
      {
        name: 'Wild Animal Handler',
        altName: 'Wild Animal Handler',
      },
      {
        name: 'Dog Trainer',
        altName: 'Dog Trainer',
      },
      {
        name: 'Dog Handler',
        altName: 'Dog Handler',
      },
    ],
  },
  {
    union: '399/44',
    occupations: [{
      name: 'Hyphenate Art',
      altName: 'Hyphenate Art',
    },
    {
      name: 'Hyphenate Lead Man',
      altName: 'Hyphenate Lead Man',
    },
    {
      name: 'Hyphenate Prop Master',
      altName: 'Hyphenate Prop Master',
    },
    {
      name: 'Hyphenate Props',
      altName: 'Hyphenate Props',
    },
    {
      name: 'Hyphenate Set Dresser',
      altName: 'Hyphenate Set Dresser',
    },
    ],
  },
  {
    union: '399/80',
    occupations: [{
      name: 'Hyphenate Key Grip',
      altName: 'Hyphenate Key Grip',
    },
    {
      name: 'Hyphenate Best Boy Grip',
      altName: 'Hyphenate Best Boy Grip',
    },
    {
      name: 'Hyphenate Grip',
      altName: 'Hyphenate Grip',
    }],
  },
  {
    union: '399/728',
    occupations: [{
      name: 'Hyphenate Chief Lighting Tech',
      altName: 'Hyphenate Chief Lighting Tech (Hyph Gaffer)',
    },
    {
      name: 'Hyphenate Best Boy Electric',
      altName: 'Hyphenate Best Boy Electric (Hyph ACLT)',
    },
    {
      name: 'Hyphenate Electric',
      altName: 'Hyphenate Eelctric (Hyph Lighting Tech or SLT)',
    }],
  },
  {
    union: '488',
  },
  {
    union: '600',
    occupations: [
      {
        name: 'Camera Operator',
        altName: 'Camera Operator',
      },
      {
        name: '1st Assistant Camera',
        altName: '1st Assistant Camera',
      },
      {
        name: '2nd Assistant Camera',
        altName: '2nd Assistant Camera',
      },
      {
        name: 'Camera Loader / Utility',
        altName: 'Camera Loader / Utility',
      },
      {
        name: 'DIT',
        altName: 'DIT',
      },
      {
        name: 'Crane Operator',
        altName: 'Crane Operator',
      },
      {
        name: 'Crane Tech',
        altName: 'Crane Tech',
      },
      {
        name: 'Techno Crane Tech',
        altName: 'Techno Crane Tech',
      },
      {
        name: 'Camera Car',
        altName: 'Camera Car',
      }],
  },
  {
    union: '695',
    occupations: [
      {
        name: 'Sound Mixer',
        altName: 'Sound Mixer',
      },
      {
        name: 'Boom Operator',
        altName: 'Boom Operator',
      },
      {
        name: 'VTR',
        altName: 'VTR',
      },
      {
        name: 'VTR',
        altName: 'VTR Assistant',
      },
      {
        name: 'Playback',
        altName: 'Playback',
      },
    ],
  },
  {
    union: '705',
    occupations: [
      {
        name: 'Key Costumer',
        altName: 'Key Costumer',
      },
      {
        name: '2nd Costumer',
        altName: '2nd Costumer',
      },
      {
        name: '3rd Costumer',
        altName: '3rd Costumer',
      },
      {
        name: 'Entry Level Costumer',
        altName: 'Entry Level Costumer',
      },
      {
        name: 'Tailor',
        altName: 'Tailor (Seamstress)',
      },
    ],
  },
  {
    union: '706',
    occupations: [
      {
        name: 'Key Make-Up',
        altName: 'Key Make-Up',
      },
      {
        name: '2nd Make-Up',
        altName: '2nd Make-Up',
      },
      {
        name: '3rd Make-Up',
        altName: '3rd Make-Up',
      },
      {
        name: 'Key Hair',
        altName: 'Key Hair',
      },
      {
        name: '2nd Hair',
        altName: '2nd Hair',
      },
      {
        name: '3rd Hair',
        altName: '3rd Hair',
      },
    ],
  },
  {
    union: '728',
    occupations: [
      {
        name: 'Chief Lighting Tech',
        altName: 'Chief Lighting Tech (Gaffer)',
      },
      {
        name: 'Best Boy Electric',
        altName: 'Best Boy Electric (ACLT)',
      },
      {
        name: 'SLT',
        altName: 'SLT (Electrician)',
      },
      {
        name: 'Lighting Programmer',
        altName: 'Lighting Programmer',
      },
      {
        name: 'Lighting Technician',
        altName: 'Lighting Technician',
      },
      {
        name: 'Dimmer Board Operator',
        altName: 'Dimmer Board Operator',
      },
      {
        name: 'Entry Level Lighting Technician',
        altName: 'Entry Level Lighting Technician',
      },
    ],
  },
  {
    union: '729',
    occupations: [
      {
        name: 'Paint Foreperson On-Call',
        altName: 'Paint Foreperson On-Call',
      },
      {
        name: 'Painter',
        altName: 'Painter',
      },
    ],
  },
  {
    union: '800',
    occupations: [
      {
        name: 'Production Designer Daily On-Call',
        altName: 'Production Designer Daily On-Call',
      },
      {
        name: 'Art Director Daily On-Call',
        altName: 'Art Director Daily On-Call',
      },
      {
        name: 'Assistant Art Director Daily On-Call',
        altName: 'Assistant Art Director Daily On-Call',
      },
      {
        name: 'Illustrator On-Call',
        altName: 'Illustrator On-Call',
      },
      {
        name: 'Storyboard Artist On-Call',
        altName: 'Storyboard Artist On-Call',
      },
      {
        name: 'Graphic Artist',
        altName: 'Graphic Artist',
      },
      {
        name: 'Lead Scenic Artist',
        altName: 'Lead Scenic Artist',
      },
      {
        name: 'Scenic Artist',
        altName: 'Scenic Artist',
      },
    ],
  },
  {
    union: '871',
    occupations: [
      {
        name: 'Art Dept Coordinator On-Call',
        altName: 'Art Dept Coordinator On-Call',
      },
      {
        name: 'Script Supervisor',
        altName: 'Script Supervisor',
      },
      {
        name: 'Teleprompter',
        altName: 'Teleprompter',
      },
    ],
  },
  {
    union: '892',
    occupations: [
      {
        name: 'Costume Designer Daily On-Call',
        altName: 'Costume Designer Daily On-Call',
      },
      {
        name: 'Assistant Costume Designer Daily On-Call',
        altName: 'Assistant Costume Designer Daily On-Call',
      },
      {
        name: 'Costume Illustrator',
        altName: 'Costume Illustrator',
      },
    ],
  },
  {
    union: '884',
    occupations: [
      {
        name: 'Studio Teacher',
        altName: 'Studio Teacher (Welfare)',
      },
    ],
  },
  {
    union: '2785',
    occupations: [],
  },
  {
    union: 'SAG',
  },
  {
    union: 'DGA',
    occupations: [
      {
        name: 'Director',
        altName: 'Director',
      },
      {
        name: '1st AD',
        altName: '1st AD',
      },
      {
        name: '2nd AD',
        altName: '2nd AD',
      },
      {
        name: '2nd 2nd AD',
        altName: '2nd 2nd AD',
      },
      {
        name: 'UPM',
        altName: 'UPM',
      },
    ],
  },
];
